/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useMemo, memo, useState } from 'react';
import { Button } from 'reactstrap';
import Table from '../../Table';
import './styles.css';
import CustomSpinner from '../../Spinner/CustomSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const CompaniesCGM = memo(({ seletedCompanies, onDelete, loading, boxesData }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(seletedCompanies);
  }, [seletedCompanies]);

  const column = useMemo(
    () => [
      {
        dataIndex: 'name',
        label: 'Company Name',
        sort: (a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        },
      },
      {
        dataIndex: 'totalBoxes',
        label: 'Devices Under Management',
        sort: (a, b) => a.totalBoxes - b.totalBoxes,
      },
      {
        dataIndex: 'action',
        label: 'Action',
        render: (_, datum, index) => {
          return (
            <Button outline color="danger" onClick={() => onDelete(datum, index)}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          );
        },
      },
    ],
    [data],
  );
  if (data)
    return (
      <div className="mt-3">
        {loading ? (
          <div className="set-height">
            <CustomSpinner />
          </div>
        ) : (
          <>
            <Table data={data} column={column} showPagination boxesData={boxesData} />
            <div className="mt-3 color-grey">
              <p>Total Companies in Group: {seletedCompanies?.length}</p>
            </div>
          </>
        )}
      </div>
    );
  else return null;
});

export default CompaniesCGM;
